// extracted by mini-css-extract-plugin
module.exports = {"progressContainer":"styles_progressContainer__tZHzD","progress":"styles_progress__1B0BI"};